import { PlanogramLayout } from "../models/layout/planogram-layout";
import { ProductReference } from "../models/layout/product-reference";
import { SerializedPlanogramLayout } from "../models/serialized-planogram-layout";

export class ExportPlanogramRequest {
    planogramId: string = "";
    stateId: string | null;
    exportType: number;
    additionalData: {} = {};
    layout?: SerializedPlanogramLayout | null = null;
    constructor(planogramId: string, stateId: string | null, exportType: number, additionalData: {}, layout?: PlanogramLayout | null) {
        this.planogramId = planogramId;
        this.stateId = stateId;
        this.exportType = exportType;
        this.additionalData = additionalData;
        if (layout) {
            // Convert the Map to a regular object for serialization
            const serializedProductReference: { [key: number]: ProductReference } = {};
            layout.productReference.forEach((value, key) => {
                serializedProductReference[key] = value;
            });

            this.layout = {
                ...layout,
                productReference: serializedProductReference
            };
        }
    }
}